module.exports = __webpack_public_path__ + "static/media/CivilServices.c492ff4d.jpg";